import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "../config/Constants";
import Textfield from "./Textfield";

interface Props {
  label: string;
  placeholder?: string;
  required: boolean;
  data: any;
  onSearchChange: any;
  searchText: string;
  expiryList: any;
  onExpiryItemSelect: any;
  selectedExpiredItem: any;
}

const SearchableDropdown = ({
  label,
  required,
  placeholder,
  onSearchChange,
  searchText,
  expiryList,
  onExpiryItemSelect,
  selectedExpiredItem,
}: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
      }}
    >
      <Label>
        {label}
        {required && <Required> *</Required>}
      </Label>
      <div style={{ position: "relative" }}>
        <InputField
          placeholder={placeholder}
          onFocus={() => setOpen(!open)}
          value={selectedExpiredItem?.name || ""}
          // onBlur={() => setOpen(false)}
        />
        <img
          src={require("../assets/images/left-arrow-icon.png")}
          style={{
            rotate: "270deg",
            position: "absolute",
            right: "10px",
            top: "16px",
          }}
        />
      </div>
      {open && (
        <div
          style={{
            position: "absolute",
            top: "4rem",
            zIndex: 999,
            border: `1px solid ${Colors.dustyGray}`,
            width: "100%",
            borderRadius: "0.5rem",
            background: "white",
            maxHeight: "200px",
            padding: "0.5rem 0",
            overflowY: "auto",
          }}
        >
          <div style={{ padding: "0.5rem 1rem" }}>
            <Textfield
              placeholder={"Search"}
              variant={"none"}
              onChange={onSearchChange}
              value={searchText}
            />
          </div>
          {expiryList.map((item: any) => (
            <div
              style={{
                padding: "0.35rem 1rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => {
                onExpiryItemSelect(item);
                setOpen(false);
              }}
            >
              <div>
                <div style={{ fontSize: "14px", fontWeight: 300 }}>
                  {item.name}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: Colors.cloudyGrey,
                    fontWeight: 300,
                  }}
                >{`Expiry Date: ${item.endDate}`}</div>
              </div>
              <div>
                {item?.email === selectedExpiredItem.email ? (
                  <img
                    src={require("../assets/images/tick.png")}
                    style={{ width: "1rem" }}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Label = styled.label`
  color: ${(props) => (props.color ? props.color : Colors.purplishGrey)};
  font-family: "Poppins-Medium";
  font-size: 0.8125rem;
  line-height: 0.75rem;
`;
const Required = styled.span`
  color: ${Colors.red};
`;

const InputField = styled.input`
  width: 95%;
  padding: 0.65rem 0.5rem;
  border: 1px solid ${Colors.dustyGray};
  border-radius: 0.25rem;
  font-family: "Poppins-Bold";
  font-size: 0.8125rem;
  line-height: 0.75rem;
  color: ${Colors.secondaryBlack};
  :focus {
    outline: none;
  }
  ::placeholder {
    color: ${Colors.cloudyGrey};
    padding: 0.125rem;
    font-family: "Poppins-Book";
  }
`;

export default SearchableDropdown;
